import React from "react";
import { Tag, Space } from "antd";
import { AppleOutlined, AndroidOutlined } from "@ant-design/icons";
import Table from "src/componets/Table";
import { ColumnsType } from "antd/lib/table";

import Pagination from "src/componets/Pagination";
import { ButtonEdit } from "src/componets/Buttons";
import OptionalLink from "src/componets/OptionalLink";
import { formattedDate } from "src/helpers/DateHelpers";

import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { BundleInterface, setEditId } from "src/store/gh_market/bundlesSlice";

const _ListTable = ({ limit }: { limit: number }) => {
  const dispatch = useAppDispatch();
  const ids = useAppSelector(state => state.ghMarket.bundles.ids);
  const entities = useAppSelector(state => state.ghMarket.bundles.entities);
  const count = useAppSelector(state => state.ghMarket.bundles.count);
  const data: BundleInterface[] = ids.map((id: any) => entities[id]) as BundleInterface[];

  const columns: ColumnsType<BundleInterface> = [
    {
      key: 'name',
      title: 'Name',
      render: (_, { name, url }) => <OptionalLink link={url}>{name}</OptionalLink>,
      width: 200
    },
    {
      key: 'platform',
      title: 'Platform',
      render: (_, { platform }) => (
        <Tag
          color={platform === 'ios' ? 'blue' : 'green'}
          icon={platform === 'ios' ? <AppleOutlined /> : <AndroidOutlined />}
        >
          {platform === 'ios' ? 'iOS' : 'Android'}
        </Tag>
      ),
      width: 100
    },
    {
      key: 'created_at',
      title: 'Created at',
      render: (_, { created_at }) => <small>{formattedDate(created_at).dateTime}</small>,
      width: 125
    },
    {
      key: 'updated_at',
      title: 'Updated at',
      render: (_, { updated_at }) => <small>{formattedDate(updated_at).dateTime}</small>,
      width: 125
    },
    {
      key: 'action',
      title: 'Action',
      render: (_, { id }) => (
        <Space size="middle">
          <ButtonEdit onClick={() => dispatch(setEditId(id))} />
        </Space>
      ),
      width: 100
    }
  ];

  return (
    <div>
      <Table
        rowKey='id'
        columns={columns}
        dataSource={data}
      />

      <Pagination total={count} size={limit} />
    </div>
  );
}

export default _ListTable;
